export default __webpack_public_path__ + "images/ecb1cc624ae217d7bc1129f0738c974e-business.webp";